import type { SnackBlockItemContainer, SnackSnsIcon } from "@/lib/gql/__generated__/graphql";
import { SnackSnsColor, SnackSnsType } from "@/lib/gql/__generated__/graphql";

import type { DesignSnackBlocksFormModel, ServerModel } from "../type";

type Props = {
	snackData: ServerModel;
};

export const serverModelToInputModel = ({ snackData }: Props): DesignSnackBlocksFormModel["InputModel"] => {
	const {
		companyID,
		hotelID,
		bgImage,
		blocks,
		isShowOriginalBgImage,
		isShowLanguageSwitcher,
		logoImage,
		snsSetting,
		uuid,
	} = snackData;

	const snsColor = snsSetting?.snsColor ?? SnackSnsColor.Black;
	const snsIcons = snsSetting?.snsIcons ?? [];
	// フロントで扱いやすい形に変換
	const getSNSIconsItem = ({
		snsIcons,
		targetSNSType,
	}: {
		snsIcons: SnackSnsIcon[];
		targetSNSType: SnackSnsType;
	}) => {
		const snsIcon = snsIcons.find((snsIcon) => snsIcon.snsType === targetSNSType);

		return {
			selected: !!snsIcon,
			snsType: targetSNSType,
			url: snsIcon?.url ?? "",
		};
	};

	const inputModel: DesignSnackBlocksFormModel["InputModel"] = {
		companyID,
		hotelID,
		uuid,

		bgImage,
		logoImage,
		snsSetting: {
			snsColor,
			snsIcons: [
				getSNSIconsItem({ snsIcons, targetSNSType: SnackSnsType.Twitter }),
				getSNSIconsItem({ snsIcons, targetSNSType: SnackSnsType.Instagram }),
				getSNSIconsItem({ snsIcons, targetSNSType: SnackSnsType.Line }),
				getSNSIconsItem({ snsIcons, targetSNSType: SnackSnsType.Facebook }),
				getSNSIconsItem({ snsIcons, targetSNSType: SnackSnsType.Note }),
				getSNSIconsItem({ snsIcons, targetSNSType: SnackSnsType.Youtube }),
				getSNSIconsItem({ snsIcons, targetSNSType: SnackSnsType.Tiktok }),
				getSNSIconsItem({ snsIcons, targetSNSType: SnackSnsType.Threads }),
			],
		},
		blocks: blocks.map((block: SnackBlockItemContainer) => {
			// layoutType の型は {..., layoutType: "column-1"} | {..., layoutType: "column-2"} | {..., layoutType: "column-3"} となっており
			// const layoutType: で定義している {..., layoutType: "column-1" | "column-2" | "column-3"} という型は代入できず型エラーがでる。
			// ただ実際に代入される値としては "column-1" | "column-2" | "column-3" であることが保証されており挙動に問題はないので、anyで型エラーを回避している

			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			const layoutType: any =
				block.items.length === 1 ? "column-1" : block.items.length === 2 ? "column-2" : "column-3";

			return {
				...block,
				layoutType,
				title: block.title ?? "",
				items: block.items.map((item) => ({
					title: item.title ?? "",
					itemType: item.itemType,
					itemUUID: item.itemUUID,
					thumbnail: item.thumbnail ?? "",
				})),
			};
		}),
		isShowOriginalBgImage,
		isShowLanguageSwitcher,
	} satisfies DesignSnackBlocksFormModel["InputModel"];

	return inputModel;
};
